module.exports = __webpack_public_path__ + "img/benefitssection-bg01.a29822f0.png";